<template>
  <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y :nudge-top="hideDetails?0:24">
    <template v-slot:activator="{ on }">
      <v-text-field label="Date range " dense readonly v-on="on" v-model="dateDisplay" class="text-body-2 cursor-pointer"
                    append-icon="mdi-menu-down" @click:append="dateMenu=true" :hide-details="hideDetails"/>
    </template>
    <v-card>
      <v-container class="pa-0">
        <v-row no-gutters>
          <v-col class="text-caption overflow-y" style="height:290px;border-right:thin solid #ddd">
            <template v-for="(option,index) in calendarOptions">
              <v-list-item v-if="option.text" :key="index" class="px-8" dense @click="selectOption(index)">{{option.text}}</v-list-item>
              <v-divider v-else/>
            </template>
          </v-col>
          <v-col>
            <v-date-picker v-model="dateRange" no-title range @change="change"/>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>

</template>

<script>
import {format,startOfWeek,endOfWeek,startOfMonth,lastDayOfMonth,startOfQuarter,lastDayOfQuarter,startOfYear,lastDayOfYear,add} from 'date-fns'

export default {
  name: 'DateRange',
	props: {
		value: {type:String,required:false},
		from: {type:String,required:false},
    to: {type:String,required:false},
    hideDetails: {type:Boolean,required:false,default:false},
    option: {type:String,required:false,default:'Last 30 days'}
  },
  data() {
    return {
      dateMenu: false,
      dateRange: [this.from,this.to],
      calendarOptions: [
        {text:'Last 30 days', set:() => {return [add(new Date(),{days:-29}),new Date()]}},
        {text:'Last 60 days', set:() => {return [add(new Date(),{days:-59}),new Date()]}},
        {text:'Last 90 days', set:() => {return [add(new Date(),{days:-89}),new Date()]}},
        {text:'Last 365 days', set:() => {return [add(new Date(),{days:-364}),new Date()]}},
        {divider:true},
        {text:'This week', set:() => {return [startOfWeek(new Date()),endOfWeek(new Date())]}},
        {text:'This month', set:() => {return [startOfMonth(new Date()),lastDayOfMonth(new Date())]}},
        {text:'This quarter', set:() => {return [startOfQuarter(new Date()),lastDayOfQuarter(new Date())]}},
        {text:'This year', set:() => {return [startOfYear(new Date()),lastDayOfYear(new Date())]}},
        {divider:true},
        {text:'Last week', set:() => {return [add(startOfWeek(new Date()),{days:-7}),add(endOfWeek(new Date()),{days:-7})]}},
        {text:'Last month', set:() => {return [add(startOfMonth(new Date()),{months:-1}),lastDayOfMonth(add(startOfMonth(new Date()),{months:-1}))]}},
        {text:'Last quarter', set:() => {return [add(startOfQuarter(new Date()),{months:-3}),lastDayOfQuarter(add(startOfQuarter(new Date()),{months:-3}))]}},
        {text:'Last year', set:() => {return [add(startOfYear(new Date()),{years:-1}),lastDayOfYear(add(startOfYear(new Date()),{years:-1}))]}},
        {divider:true},
        {text:'Today', set:() => {return [new Date(),new Date()]}},
        {text:'Yesterday', set:() => {return [add(new Date(),{days:-1}),add(new Date(),{days:-1})]}}
      ],
    }
  },
  computed: {
    dateDisplay() {
      if (!this.dateRange[0] || !this.dateRange[1])
        return;
      const dateFormat = 'yyyy-MM-dd';
      const dpFrom = this.dateRange[0].split('-');
      const dpTo = this.dateRange[1].split('-');
      return `${format(new Date(dpFrom[0],dpFrom[1]-1,dpFrom[2]),dateFormat)} to ${format(new Date(dpTo[0],dpTo[1]-1,dpTo[2]),dateFormat)}`;
    }
  },
  created() {
    if (this.dateRange[0] && this.dateRange[1])
      this.change();
    else {
      const calendarOption = this.calendarOptions.findIndex(o => o.text === this.option);
      if (calendarOption !== -1)
        this.selectOption(calendarOption);
    }
  },
  methods: {
    reset() {
      this.selectOption(0);
    },
    selectOption(selected) {
      let newDate;
      newDate = this.calendarOptions[selected].set();
      this.dateRange = [format(newDate[0],'yyyy-MM-dd'),format(newDate[1],'yyyy-MM-dd')]
      this.change();
    },
		change() {
      this.dateMenu = false;
      this.$emit('update:from', this.dateRange[0]);
      this.$emit('update:to', this.dateRange[1]);
			this.$emit('input',this.dateDisplay);
      this.$emit('change',this.dateDisplay);
    }
  }
}
</script>